import React from 'react';
import { businessInfo, translations } from '../data/mock';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const t = translations.footer;
  const nav = translations.nav;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src={businessInfo.logoDarkUrl}
              alt={businessInfo.name}
              className="h-14 w-auto mb-6"
            />
            <p className="text-gray-400 max-w-md leading-relaxed mb-6">
              {t.description}
            </p>
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2">
              <span className="w-2 h-2 bg-emerald-500 rounded-full" />
              <span className="text-sm text-gray-300">{t.badge}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">{t.quickLinks}</h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {nav.services}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {nav.howItWorks}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {nav.whyUs}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {nav.contact}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-6">{t.contact}</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span>{businessInfo.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>{businessInfo.address}</span>
                </div>
              </li>
              <li>
                <div className="flex items-center gap-3 text-gray-400">
                  <Clock className="w-5 h-5" />
                  <span>{businessInfo.hours}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} {businessInfo.name}. {t.copyright}
            </p>
            <div className="flex items-center gap-6">
              <span className="text-gray-500 text-sm">{t.diagnosticsFree}</span>
              <span className="text-gray-700">•</span>
              <span className="text-gray-500 text-sm">{t.transparentPricing}</span>
              <span className="text-gray-700">•</span>
              <span className="text-gray-500 text-sm">{t.fastTurnaround}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
